import React from 'react';
import { FormCardData } from '../../types/types';
import './_formCard.scss';

type FormCardProps = { cardData: FormCardData };

const FormCard: React.FC<FormCardProps> = (props) => {
  const { name, date, city, gender, fileName } = props.cardData;
  return (
    <div className="form-card" data-testid="form-card">
      <div className="form-card__info">
        <h3 className="form-card__title">{name}</h3>
        <ul className="form-card__props">
          <li className="form-card__props-item">
            date: <span className="info__value">{date}</span>
          </li>
          <li className="card__props-item">
            city: <span className="info__value">{city}</span>
          </li>
          <li className="form-card__props-item">
            gender: <span className="info__value">{gender}</span>
          </li>
          <li className="card__props-item">
            filename : <span className="info__value">{fileName}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FormCard;
